import React from 'react'
import ModalEliminar from './ModalEliminar'
import ModalEditarProducto from './ModalEditarProducto'
import {useDispatch, useSelector} from 'react-redux'
import {State} from '../../../../../reducers'
import {
  facturacionArrayProductoClearAll,
  facturacionArrayProductoDeleteOne,
  facturacionModalsClose,
} from '../../../../../actions/facturacion/facturacionProductos.actions'
import {generalOpenModalInfo} from '../../../../../actions/general.actions'

const ModalsGeneracionFactura = () => {
  const {activeEliminarUno, activeQuitarTodo, activeEditar} = useSelector(
    (state: State) => state.facturacion.modals
  )
  const dispatch = useDispatch()

  const closeModalEliminar = () => dispatch(facturacionModalsClose())

  const actionEliminar = () => {
    if (activeEliminarUno) {
      dispatch(facturacionArrayProductoDeleteOne())
      dispatch(generalOpenModalInfo('El producto fue eliminado satisfactoriamente.'))
    } else {
      dispatch(facturacionArrayProductoClearAll())
      dispatch(generalOpenModalInfo('Todos los productos han sido eliminados satisfactoriamente.'))
    }

    closeModalEliminar()
  }
  return (
    <>
      {(activeEliminarUno || activeQuitarTodo) && (
        <ModalEliminar
          eliminar={activeEliminarUno ? true : false}
          closeModalEliminar={closeModalEliminar}
          actionEliminar={actionEliminar}
        />
      )}
      {activeEditar && <ModalEditarProducto />}
    </>
  )
}

export default ModalsGeneracionFactura
